import GuideService from "../../../../services/catalogs/GuideService";
import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";

export const REQUEST_CREATE_GUIDE = "REQUEST_CREATE_GUIDE";
export const CREATE_GUIDE_SUCCESS = "CREATE_GUIDE_SUCCESS";
export const CREATE_GUIDE_ERROR = "CREATE_GUIDE_ERROR";

function requestCreateGuide() {
  return {
    type: REQUEST_CREATE_GUIDE,
  };
}

function createGuideSuccess(json) {
  return {
    type: CREATE_GUIDE_SUCCESS,
    message: json.data,
  };
}

function createGuideError(json) {
  return {
    type: CREATE_GUIDE_ERROR,
    error: json.data,
  };
}

export function createGuide(payload) {
  return (dispatch) => {
    dispatch(requestCreateGuide());
    return GuideService.postGuide(payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(createGuideSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(createGuide(payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(createGuideError(json.data));
      }
    });
  };
}
